import AuthGuard from "@/components/AuthGuard";
import PermissionGuard from "@/components/PermissionGuard";
import { PATH_PERMISSION_DENIED } from "@/constants";
import { Operation } from "@/types/permissions";
import { PropsWithChildren } from "react";
import { Navigate } from "react-router-dom";

interface RouteGuardProps extends PropsWithChildren {
  permission?: Operation;
}

export default function RouteGuard({
  children,
  permission = Operation.Read,
}: RouteGuardProps) {
  return (
    <AuthGuard>
      <PermissionGuard
        permission={permission}
        resolveTo={<Navigate to={PATH_PERMISSION_DENIED} replace />}
      >
        {children}
      </PermissionGuard>
    </AuthGuard>
  );
}
